import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MembershipPlanFeatureDto } from '../../../../shared/services';

export type PaymentOption = 'current-month' | 'current-month-plus-next' | 'next-period';

export interface PriceBreakdownItem {
  label: string;
  amount: number;
}

export interface PriceBreakdown {
  items: PriceBreakdownItem[];
  total: number;
}

@Component({
  selector: 'app-payment-options-modal',
  standalone: true,
  imports: [CommonModule, CurrencyPipe],
  templateUrl: './payment-options-modal.html',
  styleUrl: './payment-options-modal.css',
})
export class PaymentOptionsModal {
  @Input() open = false;
  @Output() openChange = new EventEmitter<boolean>();
  @Input() currentMonthPrice = 0;
  @Input() currentMonthPlusNextPrice = 0;
  @Input() currentMonthBreakdown: PriceBreakdown | null = null;
  @Input() nextMembershipBreakdown: PriceBreakdown | null = null;
  @Input() selectedFeatures: MembershipPlanFeatureDto[] = [];
  @Input() billingCycle: 'monthly' | 'yearly' = 'monthly';

  @Output() confirm = new EventEmitter<PaymentOption>();
  @Output() cancel = new EventEmitter<void>();

  onBackdropClick() {
    if (this.open) {
      this.onCancel();
    }
  }

  onCancel() {
    this.open = false;
    this.openChange.emit(false);
    this.cancel.emit();
  }

  onSelectOption(option: PaymentOption) {
    this.confirm.emit(option);
    this.open = false;
    this.openChange.emit(false);
  }

  getFeatureNames(): string {
    if (this.selectedFeatures.length === 0) return '';
    return this.selectedFeatures.map(f => f.featureName).join(', ');
  }
}

